<template>
  <div id="repairr-create-upload">
    <div class="upload" v-for="(base, index) in baseOptions" :key="index">
      <div class="upload-title font-labelheavy">
        {{ base.label }}<span>文件格式支持pdf</span>
      </div>
      <div class="upload-pdf">
        <div
          class="upload-pdf__content"
          v-for="item in repairRecord[base.type]"
          :key="item.fileUid"
          @click="handleUpload(item.fileUrl)"
        >
          <div class="iconfont icon-pdf"></div>
          <div class="upload-pdf__name">{{ item.fileName }}</div>
          <span
            @click="handleDelete(item.fileUid, base.type)"
            v-if="visibleEdit"
            class="iconfont icon-shanchu1"
          ></span>
        </div>
        <div class="upload-pdf__box"></div>
      </div>
      <file-uploader
        :multifile="true"
        v-show="visibleEdit"
        fileAccept=".pdf"
        :typeFile="base.type"
        @onFileChange="handleChangeFile"
      >
        <div class="upload-content">
          <div class="upload-content__btn">选择文件上传</div>
        </div>
      </file-uploader>
    </div>
  </div>
</template>

<script>
import { getFileName } from '../../config/utils';
const fileType_map = new Map([
  ['investigationReport', 0],
  ['designScheme', 1],
  ['constructionScheme', 2],
  ['completionReport', 3],
  ['approvalDocument', 4]
]);
import fileUploader from '../layout/file-uploader.vue';
export default {
  components: { fileUploader },
  props: {
    repairRecord: {
      type: Object,
      default: () => ({})
    },
    visibleEdit: {
      type: Boolean
    }
  },
  data() {
    return {
      baseOptions: [
        {
          label: '批复文件',
          type: 'approvalDocument'
        },
        {
          label: '勘察报告',
          type: 'investigationReport'
        },
        {
          label: '设计方案',
          type: 'designScheme'
        },
        {
          label: '施工方案',
          type: 'constructionScheme'
        },
        {
          label: '竣工报告',
          type: 'completionReport'
        }
      ]
    };
  },
  methods: {
    handleChangeFile({ files, typeFile }) {
      // getFileName;
      //
      const fileTypeEnum = fileType_map.get(typeFile);
      Array.from(files).forEach((item, index) => {
        const fileItem = {
          fileName: getFileName(item),
          fileTypeEnum,
          file: item,
          fileUrl: '',
          fileUid: index + Date.now()
        };
        this.repairRecord[typeFile].push(fileItem);
      });
    },
    handleDelete(id, type) {
      const deleteIndex = this.repairRecord[type].findIndex(item => {
        return item.fileUid == id;
      });
      this.repairRecord[type].splice(deleteIndex, 1);
    },
    handleUpload(url) {
      if (!this.visibleEdit) {
        let a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    }
  }
};
</script>

<style lang="scss">
#repairr-create-upload {
  .upload {
    margin: 20px 0;
    &-title {
      font-size: 16px;
      span {
        margin-left: 5px;
        font-size: 14px;
        color: #aaa;
      }
    }
    &-pdf {
      display: flex;
      justify-content: space-between;
      width: 100%;
      flex-wrap: wrap;
      margin-top: 15px;
      .icon-shanchu1 {
        position: absolute;
        top: -15px;
        right: -15px;
        font-size: 30px;
        color: $color-primary;
      }
      &__box {
        margin-top: 15px;
        width: 200px;
      }
      &__content {
        display: flex;
        position: relative;
        align-items: center;
        cursor: pointer;
        margin-top: 15px;
        width: 200px;
        height: 53px;
        background-color: #f2f2f2;
        border-radius: 4px;
        .icon-pdf {
          font-size: 30px;
          color: $color-primary;
          margin-right: 5px;
        }
      }
    }
    &-content {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 0px;
      width: 100%;
      height: 106px;
      background-color: #ddd;
      &__btn {
        width: 121px;
        height: 36px;
        background-color: $color-primary;
        color: #fff;
        line-height: 36px;
        text-align: center;
        border-radius: 4px;
      }
    }
  }
}
</style>
